import React, { useEffect } from 'react';
import { targetsForSite } from './utahBackfillContract';

export function UtahProviderTarget({ siteId, value, onChange }) {
  const targets = targetsForSite(siteId);
  const automaticDomain = targets.length === 1 ? targets[0].domain : '';
  const selected = value || automaticDomain;
  useEffect(() => {
    if (!value && automaticDomain) onChange(automaticDomain);
  }, [value, automaticDomain, onChange]);
  return <div>
    <label htmlFor="utah-provider-target" className="block text-sm font-medium text-gray-700 mb-2">Provider target *</label>
    <select id="utah-provider-target" value={selected} onChange={event => onChange(event.target.value)}
      className="w-full p-2 border border-gray-300 rounded-md" required>
      <option value="">Select a provider target</option>
      {targets.map(target => <option key={target.domain} value={target.domain}>{target.label}</option>)}
    </select>
    <p className="text-sm text-gray-600 mt-2">
      Select site 286 or 110 and the provider whose 835 files you want to retrieve.
      Use a range of up to 366 days, including both Pay Cycle Dates. Files unavailable in PRISM will be reported separately.
    </p>
  </div>;
}

export function UtahBackfillResult({ job }) {
  const result = job.result || {};
  const missing = (result.ra_results || []).filter(row => row.outcome === 'no_835');
  const outcomeText = {
    no_records: 'No RAs matched the requested dates and NPI.',
    no_835_available: 'No 835 files were available for the listed RAs.',
    duplicates_only: 'All retrieved files were already recorded for this site.',
    incomplete_backfill: 'Collection is incomplete. Earlier accepted files are retained.',
    cancelled: 'Backfill cancelled. Earlier accepted files are retained.',
  }[result.outcome];
  return <div className="text-sm mt-2 text-gray-700">
    {result.scope && <p>Pay Cycle Dates: {result.scope.from_date}–{result.scope.to_date}; NPI {result.scope.npi}</p>}
    <p>{result.stage || 'Waiting'} · {result.ras_processed || 0} RAs processed · {result.ingestions_succeeded || 0} accepted · {result.duplicates || 0} duplicates · {result.no_835_count || 0} unavailable</p>
    {outcomeText && <p>{outcomeText}</p>}
    {job.status === 'COMPLETED' && <p>Available-file collection complete. Accepted files have been submitted for processing.</p>}
    {job.error_message && <p className="text-red-700">{job.error_message}</p>}
    {result.ingestion_outcome_unknown && <p className="text-red-700">An ingestion outcome needs reconciliation before retrying.</p>}
    {missing.length > 0 && <details><summary>Unavailable 835 files ({missing.length})</summary>
      <ul>{missing.map(row => <li key={row.ra_number}>RA {row.ra_number} — {row.pay_cycle_date}</li>)}</ul>
    </details>}
  </div>;
}
